import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import { BootstrapVue, IconsPlugin, SidebarPlugin, NavbarPlugin  } from 'bootstrap-vue'
import axios from 'axios'
import firebase from 'firebase/app'
import Loading from 'vue-loading-overlay'
import Vuelidate from 'vuelidate'
import moment from 'moment';
import * as Sentry from '@sentry/vue';
import { Integrations } from '@sentry/tracing';

Sentry.init({
  Vue,
  dsn: "https://ed59b9f9f1014c56b0b1bdae29f13b43@o815328.ingest.sentry.io/5807013",
  integrations: [new Integrations.BrowserTracing()],

  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: 1.0,
});
Vue.use(Vuelidate)
 
let firebaseConfig = {
  apiKey: "AIzaSyCsKteUeJRNhrRIPq-dfNSifKswXUoGL4k",
  authDomain: "createch-energias.firebaseapp.com",
  databaseURL: "https://createch-energias.firebaseio.com",
  projectId: "createch-energias",
  storageBucket: "createch-energias.appspot.com",
  messagingSenderId: "908633945187",
  appId: "1:908633945187:web:c3ea47cdc4c67f6415f456"
}; 

// vSelect
import vSelect from 'vue-select' 
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';


firebase.initializeApp(firebaseConfig);

Vue.use(BootstrapVue)
Vue.use(IconsPlugin)
Vue.use(SidebarPlugin)
Vue.use(NavbarPlugin)

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

import '@fortawesome/fontawesome-free/css/all.css'
import '@fortawesome/fontawesome-free/js/all.js'
  
import VueFullPage from 'vue-fullpage.js' 
Vue.use(VueFullPage);

import JDTable from 'vue-jd-table';

import "@fortawesome/fontawesome-free/css/all.min.css";
import 'vue-jd-table/dist/jd-table.min.css';

Vue.component( 'jdtable',JDTable );




Vue.config.productionTip = false

//axios.defaults.baseURL = 'http://localhost:5000/api/v1/'
//axios.defaults.baseURL = 'http://192.168.0.195:5000/api/v1/' 
axios.defaults.baseURL = 'https://api.createchenergias.mx/api/v1/'

axios.interceptors.request.use(
  (config) => { 
   
    let token = localStorage.getItem('token'); 
    if (token) {
      config.headers['x-access-token'] = `${ token }`;
    }   
    return config;
  }, 

  (error) => { 
    return Promise.reject(error);
  }
);
 
/**  
axios.interceptors.response.use(function (response) { 
  console.log(response);
  return response;
   
}, function (error) { 
  return Promise.reject(error);
});
*/
axios.interceptors.response.use((response) => {
  return response
},
function (error) {
 if(error.response.status === 401) {  
  store.dispatch('salir'); 
 }  
  // return Error object with Promise
  return Promise.reject(error);
});
Vue.mixin({
  methods: {
    esAdministrador() { 
      return this.$store.state.usuario && store.state.usuario.rol == 'Administrador';
    },
    esSupervisor() {
      return this.$store.state.usuario && store.state.usuario.rol == 'Supervisor';
    },
    esVendedor() {
      return this.$store.state.usuario && store.state.usuario.rol == 'Vendedor';
    },
    makeToast(texto,titulo) {
      this.$bvToast.toast(texto, {
        title: titulo,
        autoHideDelay: 2000,
        variant:'danger'
      })
    }
  }
})
Vue.use(Loading, { 
  color: 'red'
})
Vue.filter('formatDate', function(value) {
  if (value) {
    return moment(String(value)).format('MM/DD/YYYY')
  }
});
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
